import { useState } from "react";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { useTranslation } from "react-i18next";
import { ModalAtom, TextFieldAtom } from "../../../../components/atoms/atom";

function AddPriorityModal(props) {
	const { show, onClose, onSubmit, mode, priorityInfo = {} } = props;
	const { t } = useTranslation();

	const [labelObj, setLabelObj] = useState({
		value: priorityInfo?.label || '',
		error: '',
	});

	const onAddPriority = () => {
		if (!labelObj.value) {
			setLabelObj({ ...labelObj, error: 'error-priority-label-required' });
			return;
		}

		onSubmit({
			...priorityInfo,
			label: labelObj.value,
		});
	};

	return (
		<ModalAtom
			title={t(mode === 'add' ? 'add-priority' : 'edit-priority')}
			show={show}
			handleClose={onClose}
			handleSubmit={onAddPriority}
			body={
				<Container>
					<Row>
						<Col>
							<TextFieldAtom
								type="text"
								placeholder={t('label')}
								required
								value={labelObj.value}
								error={labelObj.error}
								onChange={(e) => {
									setLabelObj({
										...labelObj,
										value: e.target.value,
										error: e.target.value ? '' : 'error-priority-label-required'
									});
								}}
							/>
						</Col>
					</Row>
				</Container>
			}
		/>
	);
}

export default AddPriorityModal;
